/* Independent tag/attribute filtering; cards are rendered by Shopify Liquid. */
(() => {
  'use strict';
  const page = document.querySelector('[data-catalog-section]');
  if (!page) return;
  const isSearch = page.dataset.catalogSearch === 'true';
  if (page.hasAttribute('data-search-product-only')) {
    const url = new URL(location.href); url.searchParams.set('type', 'product');
    location.replace(url); return;
  }
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  let controller, requestNumber = 0, priceTimer, lastAttempt;
  const form = () => $('[data-catalog-filters]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const disclosures = new WeakMap();
  // Animate the layout itself, then remove collapsed content from focus and display.
  function animateDisclosure(element, expanded, { details, animate = true } = {}) {
    const previous = disclosures.get(element);
    const wasExpanded = previous ? previous.expanded : (details ? details.open : !element.hidden);
    if (wasExpanded === expanded && !previous) return;
    const start = element.getBoundingClientRect().height;
    const computed = getComputedStyle(element);
    const from = { height: start + 'px', opacity: computed.opacity, paddingTop: computed.paddingTop, paddingBottom: computed.paddingBottom, marginTop: computed.marginTop, marginBottom: computed.marginBottom, borderTopWidth: computed.borderTopWidth, borderBottomWidth: computed.borderBottomWidth };
    previous?.animation.cancel(); disclosures.delete(element);
    if (details) {
      details.open = true;
      $('summary', details)?.setAttribute('aria-expanded', String(expanded));
    } else element.hidden = false;
    element.inert = !expanded;
    const finish = () => { if (details) details.open = expanded; else element.hidden = !expanded; element.inert = !expanded; };
    if (!animate || reducedMotion.matches || !element.animate) { finish(); return; }
    const natural = getComputedStyle(element);
    const visible = { height: element.getBoundingClientRect().height + 'px', opacity: 1, paddingTop: natural.paddingTop, paddingBottom: natural.paddingBottom, marginTop: natural.marginTop, marginBottom: natural.marginBottom, borderTopWidth: natural.borderTopWidth, borderBottomWidth: natural.borderBottomWidth };
    const collapsed = { height: '0px', opacity: 0, paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px', borderTopWidth: '0px', borderBottomWidth: '0px' };
    const animation = element.animate([{ ...(start ? from : collapsed), overflow: 'hidden' }, { ...(expanded ? visible : collapsed), overflow: 'hidden' }], { duration: 190, easing: 'ease-out', fill: 'both' });
    disclosures.set(element, { expanded, animation });
    animation.onfinish = () => {
      if (disclosures.get(element)?.animation !== animation) return;
      finish(); disclosures.delete(element); animation.cancel();
    };
  }
  function branchExpanded(branch) {
    return disclosures.get($('.catalog-category-children', branch))?.expanded ?? branch.open;
  }
  function setBranch(branch, expanded) {
    const content = $('.catalog-category-children', branch);
    if (content) animateDisclosure(content, expanded, { details: branch });
  }
  function initBranches() {
    $$('[data-category-branch]', form() || page).forEach(branch => {
      $('summary', branch)?.setAttribute('aria-expanded', String(branch.open));
      $('.catalog-category-children', branch).inert = !branch.open;
    });
  }
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  function readData() {
    try { return JSON.parse($('[data-catalog-filter-data]', form())?.textContent || '{}') || {}; }
    catch { return {}; }
  }
  function syncVehicle(changedKey, animate = false) {
    const f = form(); if (!f) return;
    $$('input[type="number"]', f).forEach(input => {
      if (input.value !== '' && Number.isFinite(Number(input.value))) input.value = String(Number(input.value));
      if (input.placeholder !== '' && Number.isFinite(Number(input.placeholder))) input.placeholder = String(Number(input.placeholder));
    });
    const data = readData(), records = data.records || [];
    const make = $('[data-vehicle-facet="14"]', f), model = $('[data-vehicle-facet="11"]', f), year = $('[data-vehicle-facet="10"]', f);
    if (!make) return;
    if (changedKey === '14') { if (model) model.value = ''; if (year) year.value = ''; }
    if (changedKey === '11' && year) year.value = '';
    const groups = new Map((data.groups || []).map(group => [group.key, group.chunks.flat()]));
    const labels = new Map([...groups.values()].flat().map(option => [option.tag, option.label]));
    function options(select, key, allowed, parentSelected, placeholder) {
      if (!select) return;
      const selected = select.value;
      select.replaceChildren(new Option(placeholder, ''));
      (groups.get(key) || []).filter(option => allowed.has(option.tag)).forEach(option => select.add(new Option(option.label, option.tag)));
      select.value = allowed.has(selected) ? selected : '';
      select.disabled = !parentSelected || allowed.size === 0;
      animateDisclosure(select.closest('[data-attribute-group]'), !select.disabled, { animate });
    }
    const matchingMake = make.value ? records.filter(record => record.make.includes(make.value)) : [];
    const models = matchingMake.flatMap(record => record.model).filter(tag => !data.model_makes?.[tag] || data.model_makes[tag].includes(make.value));
    options(model, '11', new Set(models), !!make.value, 'Toate modelele');
    const hasModel = model && !model.disabled;
    const matchingModel = hasModel ? (model.value ? matchingMake.filter(record => record.model.includes(model.value)) : []) : matchingMake;
    const modelLabel = normalize(labels.get(model?.value) || '');
    const years = new Set();
    matchingModel.forEach(record => record.year.forEach(tag => {
      const label = normalize(labels.get(tag) || '');
      // Multimodel products carry generation names: keep only the selected model's generations.
      if (!hasModel || record.model.length === 1 || /^[0-9]/.test(label) || label === modelLabel || label.startsWith(modelLabel + ' ') || (' ' + label + ' ').includes(' ' + modelLabel + ' ')) years.add(tag);
    }));
    options(year, '10', years, hasModel ? !!model.value : !!make.value, 'Toți anii / generațiile');
  }
  const sources=window.CatalogSources;
  function tagsFromUrl(input) {
    const url=sources.canonical(input);
    return [...url.searchParams].filter(([key])=>key.startsWith('attribute_')).map(([,value])=>value);
  }
  function setTags(input,tags) {
    const url=sources.canonical(input);
    for(const key of [...url.searchParams.keys()])if(key.startsWith('attribute_'))url.searchParams.delete(key);
    for(const tag of tags){const option=sources.byTag.get(tag);if(option)url.searchParams.set('attribute_'+option.key,tag);}
    url.searchParams.delete('page');return url;
  }
  function urlFromForm(changedKey) {
    const f = form(), url = new URL(location.href), tags = [], fields = new FormData(f);
    if (isSearch) {
      const searchOptions = [...url.searchParams].filter(([key]) => key.startsWith('options['));
      for(const key of [...url.searchParams.keys()])if(!['preview_theme_id'].includes(key))url.searchParams.delete(key);
      for (const [key, value] of searchOptions) url.searchParams.append(key, value);
      for (const [name, value] of fields) if (value !== '') url.searchParams.append(name, String(value));
      return url;
    }
    const managed = new Set();
    $$('[name^="attribute_"]', f).filter(input => !input.disabled).forEach(input => managed.add(input.name.slice(10)));
    if (changedKey === '14') { managed.add('11'); managed.add('10'); }
    if (changedKey === '11') managed.add('10');
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
    for (const [name, value] of fields) {
      if (name.startsWith('attribute_')) { if (value) tags.push(String(value)); }
      else if (value !== '') url.searchParams.set(name, String(value));
    }
    const existing = tagsFromUrl(new URL(location.href));
    tags.push(...existing.filter(tag => ![...managed].some(key => tag.startsWith('ata-' + key + '-'))));
    return setTags(url, tags);
  }
  function feedback(message, error = false) {
    const target = $('[data-catalog-status]'); if (!target) return;
    target.replaceChildren(document.createTextNode(message));
    target.classList.toggle('is-error', error);
    if (error) {
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'text-link'; retry.dataset.retryFilters = ''; retry.textContent = 'Reîncearcă'; target.append(' ', retry);
    }
    const live = $('#store-status'); if (live) live.textContent = message;
  }
  async function update(url, { historyMode = 'push', scroll = false } = {}) {
    clearTimeout(priceTimer);
    const number = ++requestNumber;
    controller?.abort(); controller = new AbortController();
    lastAttempt = { url: new URL(url), historyMode, scroll };
    const active = document.activeElement;
    const focus = active?.closest('[data-catalog-filters],.catalog-results') ? { name: active.name, value: active.value, id: active.id, pill: !!active.closest('.active-filters') } : null;
    const drawer = $('#filter-dialog'), drawerScroll = drawer?.scrollTop || 0;
    $('.catalog-results').setAttribute('aria-busy', 'true');
    page.dataset.sourceState='loading';page.classList.add('is-updating'); feedback('Se actualizează produsele…');
    const requestUrl = new URL(url); requestUrl.searchParams.set('section_id', page.dataset.catalogSection);
    try {
      url=sources.canonical(url);
      const products=await sources.results(url);
      if(number!==requestNumber)return;
      const pageNumber=Math.min(Math.max(1,Number(url.searchParams.get('page')) || 1),Math.max(1,Math.ceil(products.length/24)));
      if(url.searchParams.has('page'))url.searchParams.set('page',String(pageNumber));
      const shown=products.slice((pageNumber-1)*24,pageNumber*24);
      const content=await sources.cards(shown,controller.signal);
      if(number!==requestNumber)return;
      const results=$('.catalog-results').cloneNode(true),grid=$('.catalog-grid',results);
      grid.replaceChildren(content);
      if(!shown.length){const empty=document.createElement('div');empty.className='empty-state';const title=document.createElement('h2');title.textContent='Nu am găsit produse';const hint=document.createElement('p');hint.textContent='Încearcă să elimini filtrele sau să schimbi căutarea.';empty.append(title,hint);grid.append(empty);}
      $('[data-product-count]',results).textContent=products.length+(products.length===1?' produs':' produse');
      const sort=$('[data-sort]',results);if(sort && url.searchParams.has('sort_by'))sort.value=url.searchParams.get('sort_by');
      $$('.pagination,.active-filters',results).forEach(el=>el.remove());
      const pills=document.createElement('div');pills.className='active-filters';
      for(const [key,value] of url.searchParams){
        if(!key.startsWith('attribute_') && !key.startsWith('filter.'))continue;
        const option=sources.byTag.get(value),link=document.createElement('a'),target=new URL(url);
        if(key==='attribute_14'){target.searchParams.delete('attribute_11');target.searchParams.delete('attribute_10');}
        if(key==='attribute_11')target.searchParams.delete('attribute_10');
        target.searchParams.delete(key,value);target.searchParams.delete('page');link.href=target.href;
        link.textContent=(option?.label || (key.includes('price.gte')?'De la '+value+' lei':key.includes('price.lte')?'Până la '+value+' lei':value))+' ×';link.setAttribute('aria-label','Elimină filtrul '+(option?.label || value));pills.append(link);
      }
      if(pills.children.length){const reset=document.createElement('a'),target=new URL(url);for(const key of [...target.searchParams.keys()])if(key.startsWith('attribute_') || key.startsWith('filter.') || key==='page')target.searchParams.delete(key);reset.href=target.href;reset.textContent='Resetează filtrele';reset.dataset.resetFilters='';pills.append(reset);$('.catalog-toolbar',results).append(pills);}
      const pages=Math.ceil(products.length/24);
      if(pages>1){const nav=document.createElement('nav');nav.className='pagination';nav.setAttribute('aria-label','Paginare');const numbers=[...new Set([1,pageNumber-1,pageNumber,pageNumber+1,pages])].filter(n=>n>0 && n<=pages).sort((a,b)=>a-b);for(const n of numbers){const link=document.createElement('a'),target=new URL(url);target.searchParams.set('page',String(n));link.href=target.href;link.textContent=String(n);if(n===pageNumber)link.setAttribute('aria-current','page');nav.append(link);}grid.after(nav);}
      const filters=null;
      if (number !== requestNumber) return;
      // Let a newly revealed vehicle control finish its short transition before replacing it.
      await Promise.all($$('[data-attribute-group],.catalog-category-children', form() || page).map(element => disclosures.get(element)?.animation.finished.catch(() => {})));
      if (number !== requestNumber) return;
      const categoryBranches = new Map($$('[data-category-branch]', form() || page).map(branch => [branch.dataset.categoryBranch, branchExpanded(branch)]));
      $('.catalog-results').replaceWith(results);
      if (filters && $('#filter-content')) $('#filter-content').innerHTML = filters.innerHTML;
      $$('[data-category-branch]', form() || page).forEach(branch => { if (categoryBranches.has(branch.dataset.categoryBranch)) branch.open = categoryBranches.get(branch.dataset.categoryBranch); });
      initBranches();
      reflectSelection(url);syncVehicle();
      if (historyMode === 'push' && url.href !== location.href) history.pushState({ catalog: true }, '', url);
      if(historyMode==='none' && url.href!==location.href)history.replaceState({catalog:true},'',url);
      page.dataset.sourceState='ready';feedback('');
      if ($('#store-status')) $('#store-status').textContent = $('[data-product-count]').textContent.trim();
      document.dispatchEvent(new CustomEvent('catalog:updated'));
      if (focus) {
        const controls = $$('[name]', form() || page).concat($$('[data-sort]')).filter(input => input.type !== 'hidden');
        const next = (focus.id && document.getElementById(focus.id)) || (focus.name ? controls.find(input => input.name === focus.name && (input.tagName === 'SELECT' || input.type === 'number' || input.value === focus.value)) : null);
        if (next && !next.disabled && !next.closest('[hidden]')) next.focus({ preventScroll: true });
        else if (focus.pill && !drawer?.open) { $('[data-product-count]').tabIndex = -1; $('[data-product-count]').focus({ preventScroll: true }); }
      }
      if (drawer?.open) drawer.scrollTop = drawerScroll;
      if (scroll) $('.catalog-toolbar').scrollIntoView({ block: 'start', behavior: 'instant' });
    } catch (error) {
      if (error.name !== 'AbortError' && number === requestNumber){page.dataset.sourceState='error';feedback('Produsele nu au fost actualizate. Verifică conexiunea.', true);}
    } finally {
      if (number === requestNumber) { $('.catalog-results')?.removeAttribute('aria-busy'); page.classList.remove('is-updating'); }
    }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sort]')) {
      const url = form() ? urlFromForm() : new URL(location.href); url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page'); update(url); return;
    }
    if (!event.target.closest('[data-catalog-filters]') || event.target.matches('[data-filter-options]')) return;
    if (event.target.matches('[data-vehicle-facet]')) syncVehicle(event.target.dataset.vehicleFacet, true);
    if (form().reportValidity()) update(urlFromForm(event.target.dataset.vehicleFacet));
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-catalog-filters] input[type="number"]')) return;
    clearTimeout(priceTimer); priceTimer = setTimeout(() => { if (form().reportValidity()) update(urlFromForm()); }, 650);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-catalog-filters],.catalog-results .sort-form')) return;
    event.preventDefault(); if (form()) {if (form().reportValidity()) update(urlFromForm());} else if (isSearch) {const url = new URL(location.href); for (const [key,value] of new FormData(event.target)) url.searchParams.set(key,value); url.searchParams.delete('page'); update(url);}
  });
  document.addEventListener('click', event => {
    const summary = event.target.closest('[data-category-branch] > summary');
    if (summary) {
      event.preventDefault();
      const branch = summary.parentElement, expanded = !branchExpanded(branch);
      if (expanded) {
        const siblings = branch.parentElement.parentElement;
        $$(':scope > .catalog-category-item > [data-category-branch]', siblings).forEach(other => {
          if (other !== branch && branchExpanded(other)) setBranch(other, false);
        });
      }
      setBranch(branch, expanded); return;
    }
    if (event.target.closest('[data-retry-filters]')) { if (lastAttempt) update(lastAttempt.url, lastAttempt); return; }
    const link = event.target.closest('.active-filters a,[data-reset-filters],.catalog-results .pagination a');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault(); const url = new URL(link.href);
    const tag = link.closest('[data-remove-tag]')?.dataset.removeTag;
    if (tag) {
      const current = new URL(location.href);
      let tags = tagsFromUrl(current).filter(value => value !== tag);
      if (tag.startsWith('ata-14-')) tags = tags.filter(value => !/^ata-(11|10)-/.test(value));
      if (tag.startsWith('ata-11-')) tags = tags.filter(value => !value.startsWith('ata-10-'));
      update(setTags(current, tags)); return;
    }
    if (link.matches('[data-reset-filters]')) {
      const current = new URL(location.href), sort = current.searchParams.get('sort_by');for(const key of [...url.searchParams.keys()])if(key.startsWith('attribute_') || key.startsWith('filter.') || key==='page')url.searchParams.delete(key);if(sort)url.searchParams.set('sort_by',sort);if(current.searchParams.has('preview_theme_id'))url.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
    }
    update(url, { scroll: !!link.closest('.pagination') });
  });
  window.addEventListener('popstate', () => update(new URL(location.href), { historyMode: 'none' }));
  function reflectSelection(url){
    const f=form();if(!f)return;
    for(const control of $$('[name]',f)){
      if(control.name.startsWith('attribute_') || control.name.startsWith('filter.')){
        const value=url.searchParams.getAll(control.name);
        if(['radio','checkbox'].includes(control.type))control.checked=value.length?value.includes(control.value):control.value==='';
        else control.value=value[0] || '';
      }
    }
  }
  async function prepareFilters(){
    if(!form())return;
    const url=sources.canonical(new URL(location.href));
    const base=new URL(isSearch?sources.config.allUrl:form().dataset.collectionUrl,location.origin);
    const products=await sources.load(base),used=new Set(products.flatMap(p=>p.values));
    const data=readData();
    data.groups=(data.groups || []).map(g=>({...g,chunks:[(sources.groups.find(x=>x.key===g.key)?.options || g.chunks.flat()).filter(o=>used.has(o.tag))]}));
    data.records=products.map(p=>Object.fromEntries([['make','14'],['model','11'],['year','10']].map(([name,key])=>[name,p.values.filter(v=>sources.byTag.get(v)?.key===key)]))).filter(r=>r.make.length);
    const script=$('[data-catalog-filter-data]',form());if(script)script.textContent=JSON.stringify(data);
    for(const g of data.groups){
      const container=$('[data-attribute-group="'+g.key+'"]',form());if(!container)continue;
      const choices=g.chunks.flat(),select=$('select',container);
      if(select){const placeholder=select.options[0]?.textContent || 'Toate';select.replaceChildren(new Option(placeholder,''),...choices.map(o=>new Option(o.label,o.tag)));}
      else {const values=$('.facet-values',container);if(!values)continue;values.replaceChildren();for(const o of [{tag:'',label:'Toate'},...choices]){const label=document.createElement('label');label.className='filter-option'+(!o.tag?' facet-all':'');if(o.tag)label.dataset.optionLabel=o.label;const input=document.createElement('input');input.type='radio';input.name='attribute_'+g.key;input.value=o.tag;const span=document.createElement('span');span.textContent=o.label;label.append(input,span);values.append(label);}}
    }
    reflectSelection(url);syncVehicle();
  }
  initBranches();
  reflectSelection(sources.canonical(new URL(location.href)));syncVehicle();
  lastAttempt={url:sources.canonical(new URL(location.href)),historyMode:'none',scroll:false};
  prepareFilters().then(()=>{const url=sources.canonical(new URL(location.href));if(isSearch || tagsFromUrl(url).length)return update(url,{historyMode:'none'});page.dataset.sourceState='ready';}).catch(()=>{page.dataset.sourceState='error';feedback('Filtrele nu au putut fi încărcate. Reîncearcă.',true);});
})();
